import * as _ from 'lodash-es';
import { computed } from 'vue';
import { acceptHMRUpdate, defineStore } from 'pinia';
import { usePracticeStore } from './practice.store';
import { ResourceConfig } from '@repo/core/resources';
import { useClientPortalService } from '@repo/modules/server';

export const useClientPortalStore = defineStore('clientPortal', () => {
  // services
  const clientPortalService = useClientPortalService();

  // stores
  const practiceStore = usePracticeStore();

  // getters
  const isClientPortalEnabled = computed(() => {
    return _.isEqual(ResourceConfig.enableClientPortal, 'true') && practiceStore.currentPractice?.clientPortalBeta;
  });

  // actions
  const fetchStatus = () => {
    return clientPortalService.status();
  };

  const getters = {
    isClientPortalEnabled
  };
  const actions = { fetchStatus };

  return { ...getters, ...actions };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useClientPortalStore, import.meta.hot));
}
